import React from 'react';
import CONFIG from "../../../config";

const { LINKS } = CONFIG;

interface IGetMoney {
    className: string;
}

const GetMoney: React.FC<IGetMoney> = ({ className }) => (
    <a
        className={className}
        href={LINKS.BAIBOL.MAIN}
        target="_blank"
        rel="noopener noreferrer nofollow"
    >Получить деньги</a>
);

export default GetMoney;
